document.querySelector('.navbar-toggler').addEventListener('click', function() {
    this.classList.toggle('cross');
    });

//   nav realted js 
  
window.onscroll = function() {
    checkStickyNavbar();
};
window.onresize = function() {
    setNavbarWidth();
};
var navbar = document.getElementById("navbarsticky");
var navContainer = document.getElementById("nav-container");
var sticky = navbar.offsetTop;
function checkStickyNavbar() {
    if (window.pageYOffset >= sticky) {
        navbar.classList.add("sticky");
        setNavbarWidth();
    } else {
        navbar.classList.remove("sticky");
        navbar.style.width = '100%';
    }
}
function setNavbarWidth() {
    if (navbar.classList.contains('sticky')) {
        navbar.style.width = (navContainer.getBoundingClientRect().width - 23.98) + 'px';
    }
}
setNavbarWidth();
    